import React from "react";

const Article = () => (
  <>
    <div className="articolo">
      <div className="titolo">
        <h1 className="tit">
          The Kano PC partners with <br /> Microsoft to boost Creative <br />{" "}
          Education
        </h1>
      </div>
      <div className="descr">
        <div className="tempo">
          <p>10 minuti</p>
        </div>
        <div className="icone">
          <img src="/svg/tech.svg" alt="tech" />
          <img src="/svg/shape-toy.svg" alt="kids" />
        </div>
      </div>
    </div>
    <div className="text">
      <p>
        Kano is partnering with Microsoft to bring creative education tools to
        the classroom and support creative tech learning for children.
        <br /> <br /> The Kano PC is a new product that stays true to the
        mission of Kano to create makers of technology and not just consumers
        thereof. <br /> <br /> The Kano PC will be buildable and comes with an
        11.6inch touchscreen and Intel Atom x5-Z8350 Quad-core 1.44 GHz
        processor with 4GB RAM memory and 64GB storage which can be upgraded via
        a micro SD slot. <br /> <br /> From what we can see it will be a similar
        experience as the Computer Kit Complete, supported with an instruction
        booklet to build the computer whilst learning how the technology works.{" "}
        <br /> <br /> The case is clear so you can see the 'inside the black
        box'. <br /> <br /> The "How Computers Work' app should also help kids
        get a better understanding of how the tech they use work. <br /> <br />{" "}
        The Kano PC will run Windows 10 in S mode which can support Office
        Suite. You will also have access to many Kano apps, like Kano World,
        Kano Art, Music and Games and Learn to Code app. <br /> <br /> The
        computer will also support 3D paint, to make 3D models and send to a
        printer. <br /> <br /> The touchscreen makes it really accessible for
        younger children and probably eliminates the need for a mouse. <br />{" "}
        <br /> Bring on the future and a new way of working with computers.{" "}
        <br /> <br /> The Kano PC is built with education in mind and looks to
        be a welcome tool in schools and home alike. An added benefit, is that
        Kano PC will ship with Minecraft: Education Edition, the same app that
        comes with Windows 10. <br /> <br />
        We are firm believers that kids today need to understand how the
        technology works so that they can become the makers and fixers thereof
        in the future. <br /> <br /> We need more companies to create products,
        Kano PC, that encourage creativity and curiosity to enable our children
        to learn the right skills and have an understanding of the tech age we
        live in.
      </p>
      <img src="kano.png" alt="kano" style={{ width: "100%" }} />
    </div>
  </>
);

export default Article;
